export default "__VITE_ASSET__wbxDy9V___"